export default __webpack_public_path__ + "static/media/patientRecovering.6a0175a7.png";